import React, { useState, useEffect } from 'react';
import { LinearGradient } from 'expo-linear-gradient';
import { fontFamily } from '../../helpers/fontFamily';
import { Image, Text, View, StyleSheet, TouchableOpacity } from 'react-native';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import i18n from 'i18n-js';
import StockMenu from './StockMenu';
import useWidth from '../scanToCartScanning/useWidth';

const DisplaySuggestedImage = (props) => {
  const [showDefault, setShowDefault] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [isRemoved, setIsRemoved] = useState(false);
  const width = useWidth();

  let slider_image = [];

  useEffect(() => {
    if (props.images?.length < 1) {
      setShowDefault(true);
      return;
    }
    setShowDefault(false);
  }, [props.images?.[0]?.image]);

  useEffect(() => {
    if (isRemoved) {
      setTimeout(() => {
        props?.onPressGetOrderData();
      }, [1000]);
      setIsRemoved(false);
    }
  }, [props.removeOrderItems, isRemoved]);

  if (props.images) {
    props.images.forEach((image) => {
      if (image.image) {
        slider_image.push(image.image);
      }
    });
  }

  return (
    <View style={style.container}>
      <View style={[style.mainContainer, { width: props.getWidth(), height: width > 1440 ? '100%' : props.getWidth() }]}>
        {showDefault ? (
          <Image
            onError={props.onError}
            source={props.source}
            style={style.image}
          />
        ) : (
          <Image
            source={{ uri: slider_image[0] }}
            onError={() => {
              setShowDefault(true);
            }}
            style={style.image}
          />
        )}
        <LinearGradient
          colors={['rgba(152, 151, 151, 0.1)', 'rgba(16, 15, 15, 0.5)', 'rgba(2, 2, 2, 0.9)']}
          locations={[0, 0.55, 1]}
          start={{ x: 0, y: 0.5 }}
          end={{ x: 1, y: 0.5 }}
          style={style.gradient}
        />
        <View
          dataSet={{ componentName: 'nextItemImageCount' }}
          style={[style.container1, { marginRight: props.getMargin() }]}>
          <Text
            dataSet={{ componentName: 'nextItemCountContainer' }}
            style={style.countText}>
            {props.scannedQty} / {props.totalQty}
          </Text>
          <Text
            dataSet={{ componentName: 'nextItemCountMoretoScan' }}
            style={style.moreToScanText}>
            {props.remainingQty}{' '}
            {i18n.t("scanpackItem.moreToScanLabel")}
          </Text>
        </View>

        {!(props.hideMenu ?? false) && (
          !showMenu ? (
            <TouchableOpacity
              testID='menuIcon'
              onPress={() => { setShowMenu(true) }}
              style={style.iconContainer}>
              <i
                className="icon-menu"
                style={{ color: 'gray', fontSize: 42, marginLeft: -8, marginTop: 5 }}>
              </i>
            </TouchableOpacity>
          ) : (
            <StockMenu
              getWidth={props.getWidth}
              setShowMenu={setShowMenu}
              props={props}
              setIsRemoved={setIsRemoved}
            />
          )
        )}
      </View>
    </View>
  );
};

const mapStateToProps = state => {
  return {
    removeOrderItems: state.order.removeOrderItems,
  };
};

export default connect(mapStateToProps)(DisplaySuggestedImage);

const style = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 0,
    right: 0,
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    height: '100%',
  },
  mainContainer: {
    position: 'relative',
    borderTopLeftRadius: 18,
    borderBottomLeftRadius: 18,
    marginTop: '1.5%',
    shadowColor: '#000000',
    shadowOpacity: 0.3,
    shadowRadius: 10,
    shadowOffset: {
      width: 3,
      height: 5
    },
    overflow: 'hidden',
  },
  image: {
    width: '100%',
    height: '100%',
    resizeMode: 'cover',
    borderTopLeftRadius: 18,
    borderBottomLeftRadius: 18,
  },
  gradient: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: '10%',
    height: '100%',
    zIndex: 16
  },
  container1: {
    width: '100%',
    position: 'absolute',
    textAlign: 'center',
    fontSize: 18,
    fontFamily: fontFamily.font600,
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    borderBottomLeftRadius: 18,
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: 10,
    paddingVertical: 4,
  },
  countText: {
    fontWeight: 'bold',
    fontFamily: fontFamily.font700,
    fontSize: 38,
    marginTop: 0.5,
    textAlign: 'center',
    color: '#324a64',
    lineHeight: 32
  },
  moreToScanText: {
    textAlign: 'center',
    fontSize: 18,
    color: '#000',
    fontFamily: fontFamily.font700,
    lineHeight: 19
  },
  iconContainer: {
    position: 'absolute',
    top: 5,
    right: 5,
    zIndex: 20
  }
});
